import React, { Fragment } from "react";
import { Col, Button, Spin } from "antd";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { isLoaded, isEmpty } from "react-redux-firebase";

const Landing = props => {
  // if (props.auth.isLoaded) return <Redirect to="/campaigns" />;

  if (!isLoaded(props.auth)) {
    return (
      <div style={{ marginTop: 200, textAlign: "center" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!isEmpty(props.auth)) {
    return <Redirect to="/login" />;
  }

  return (
    <div style={{ textAlign: "center", marginTop: "10%" }}>
      <img src="/assets/img/bgimage.png" alt="bg" className="landing-page" />
      <Col span={12} offset={6}>
        <h1>Welcome to Mail Hopper</h1>
        <h3 style={{ marginBottom: 40 }}>Create email campaigns and send to all your clients. </h3>
        <Fragment>
          <Button type="primary" style={{ width: 200, height: 50 }}>
            <Link to="/login">Log In</Link>
          </Button>
          <Button
            type="primary"
            style={{ width: 200, height: 50, marginLeft: 20 }}
          >
            <Link to="/register">Register</Link>
          </Button>
        </Fragment>
      </Col>
    </div>
  );
};

const mapStateToProps = ({ firebase }) => {
  return {
    auth: firebase.auth
  };
};

export default connect(mapStateToProps)(Landing);
